import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";

const VISITOR_KEY = "cgp_visitor";

function getVisitorId() {
  try {
    const existing = localStorage.getItem(VISITOR_KEY);
    if (existing) return existing;
    const id =
      typeof crypto !== "undefined" && "randomUUID" in crypto
        ? crypto.randomUUID()
        : "v-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(VISITOR_KEY, id);
    return id;
  } catch {
    return "v-" + Math.random().toString(36).slice(2);
  }
}

export default function AnalyticsTracker() {
  const { pathname } = useLocation();
  const last = useRef("");

  useEffect(() => {
    if (typeof window === "undefined") return;
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") return;
    if (process.env.NODE_ENV !== "production") return;

    const path = pathname || "/";
    if (last.current === path) return;
    last.current = path;

    const payload = JSON.stringify({
      path,
      referrer: document.referrer || "",
      visitorId: getVisitorId(),
    });
    const blob = new Blob([payload], { type: "application/json" });
    if (typeof navigator.sendBeacon === "function") {
      navigator.sendBeacon("/api/track", blob);
    } else {
      fetch("/api/track", {
        method: "POST",
        body: blob,
        credentials: "omit",
        keepalive: true,
      }).catch(() => {});
    }
  }, [pathname]);

  return null;
}